import { PolicyDiffHunkRecord } from 'src/types/workflowBuilderAPITypes';

/**
 * Merge a save-progress delta into the hunks a review already holds.
 *
 * Save-progress returns only the hunks a flush changed, with attribution unset,
 * and never adds or removes hunks. Each changed hunk is patched in by `hunk_id`
 * while its existing attribution is preserved; untouched hunks are kept as-is.
 */
export const mergeChangedHunks = (
  existingHunks: PolicyDiffHunkRecord[],
  changedHunks: PolicyDiffHunkRecord[],
): PolicyDiffHunkRecord[] => {
  const changedById = new Map(changedHunks.map(hunk => [hunk.hunk_id, hunk]));
  return existingHunks.map(hunk => {
    const changed = changedById.get(hunk.hunk_id);
    return changed ? { ...changed, attribution: hunk.attribution } : hunk;
  });
};
